/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {FunctionComponent} from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {IconButton} from '../components/buttons/IconButton';
import Tooltip from '../components/tooltip/Tooltip';
import {IconProps} from '../types/types';
import {SaveIconDefault} from './SaveIconDefault';
import {SaveIconInChange} from './SaveIconInChange';
import {SaveIconInProgress} from './SaveIconInProgress';

export const SaveIconTooltip = function(props) {
  return <Tooltip arrow {...props} />;
};

// defines the definition of the save icon props
export interface SaveIconProps extends IconProps {
  type?: 'default' | 'inprogress' | 'changed';
  onClick?: Function;
};

/**
 * Provides the mapping between state prop and the respective
 * save icon.
 */
const saveIconMap = {
  default    : SaveIconDefault,
  inprogress : SaveIconInProgress,
  changed    : SaveIconInChange
};

/**
 * Defines the Design Language System (DLS) Save Icon component.
 *
 * If you are looking for a button that shows a save icon, please see the {@link SaveIconButton}.
 */
export const SaveIcon = ({type, onClick, ...props}: SaveIconProps) => {
  const Icon: FunctionComponent<IconProps> = saveIconMap[type] || saveIconMap.default;
  return (
    <SaveIconTooltip title={translate('common:editors.shared.save')}>
      <div>
        <IconButton onClick={onClick} icon={<Icon {...props} />} />
      </div>
    </SaveIconTooltip>
  );
};
